module.exports = __webpack_public_path__ + "static/media/Euro2020Final-1407.8f659ec2.jpg";